import type { GetDateFromSearchParamsProps } from "@/utilities/date";

import { useSearchParams } from "react-router";

import { useAppLocale } from "@/services/language";
import { getDateFromSearchParams } from "@/utilities/date";

export const useMaintenancePage = () => {
  const [params] = useSearchParams();
  const locale = useAppLocale();

  const props: Omit<GetDateFromSearchParamsProps, "key"> = {
    params,
    locale,
    format: locale === "fr" ? "dddd D MMMM HH[h]mm" : "LLL",
  };

  return {
    startDate: getDateFromSearchParams({ ...props, key: "start_date" }),
    endDate: getDateFromSearchParams({ ...props, key: "end_date" }),
  };
};
